// The client's own plan (finance-pricing target). The portal client carries the portal token; the server reads the
// client from it, never from the request, and refuses anyone but the client's own contacts (403).
import { createPortalClient } from "@/services/portalClient";
import type { PortalPlan } from "../utils/portalPlan";

export const planService = {
  plan: (clientId: string) => createPortalClient(clientId, "client").get<PortalPlan>("/api/client-portal/plan"),
};
